export default __webpack_public_path__ + "media/src/assets/images/DOT_hazmat_class_4.3-d793f23476a3155495967bee18f7e061.svg";